import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

interface ScheduleInvitationProps {
  onCreateSchedule: () => void;
}

const ScheduleInvitation: React.FC<ScheduleInvitationProps> = ({ onCreateSchedule }) => {
  const [t] = useTranslation('schedule');

  return (
    <div className="card bg-base-100 shadow-xl">
      <div className="card-body items-center text-center">
        <h2 className="card-title text-primary mb-4 text-3xl">
          {t('schedule_invitation_title', 'Configura tu primer horario')}
        </h2>

        <p className="text-base-content mb-6 max-w-3xl text-lg">
          {t('schedule_invitation_description', 'Optimiza tu tiempo y mejora la experiencia de tus clientes configurando horarios de atención automatizados.')}
        </p>

        <p className="text-base-content/70 mb-8 max-w-2xl text-base">
          {t(
            'schedule_invitation_benefits',
            'Define horarios de atención, configura respuestas automáticas fuera de horario, y permite a tus clientes saber cuándo pueden recibir respuestas inmediatas.',
          )}
        </p>

        <div className="card-actions">
          <button onClick={onCreateSchedule} className="btn btn-primary btn-lg">
            {t('start_creating_schedule', 'Crear mi primer horario')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ScheduleInvitation;
